import { render } from "./SuspendedUsersAdd.vue?vue&type=template&id=e28aa0ce"
import script from "./SuspendedUsersAdd.vue?vue&type=script&setup=true&lang=js"
export * from "./SuspendedUsersAdd.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/SuspendedUsersAdd.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "e28aa0ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('e28aa0ce', __exports__)) {
    api.reload('e28aa0ce', __exports__)
  }
  
  module.hot.accept("./SuspendedUsersAdd.vue?vue&type=template&id=e28aa0ce", () => {
    api.rerender('e28aa0ce', render)
  })

}


export default __exports__